const UPDATE_GLADCHAT_STATE = 'UPDATE_GLADCHAT_STATE';

export { UPDATE_GLADCHAT_STATE };
